import Api from './api';

const DeclarationApi = {
  /** Medical-device declaration PDF for a scan, generated on the fly from current data. */
  async getScanDeclarationPdf(scanId: string): Promise<Blob> {
    const response = await Api.axios.get(`/declarations/scans/${scanId}`, {
      responseType: 'blob',
    });
    return response.data;
  },
};

export default DeclarationApi;
